import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import CommandCenterHeader from '../CommandCenterHeader/CommandCenterHeader';
import SiteUptimeHistory from '../../../modules/system/SiteUptimeHistory';

const CommandCenterShell: React.FC = () => {
  const location = useLocation();
  const isSystemPage = location.pathname === '/system';

  return (
    <div className="command-center-shell">
      <CommandCenterHeader />
      <main className="command-center-shell__content">
        <Outlet />
        {isSystemPage ? <SiteUptimeHistory /> : null}
      </main>
    </div>
  );
};

export default CommandCenterShell;
